import logo from "../../../assets/images/online-scheduler-logo.png";

const BookingHeader = ({ companyLogo, companyName }) => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center">
          {companyLogo ? (
            <img src={companyLogo} alt={companyName || "Company Logo"} className="h-10 md:h-12 object-contain py-3" />
          ) : companyName ? (
            <span className="text-lg font-semibold text-gray-900 py-3">{companyName}</span>
          ) : <div className="h-10 md:h-12" ></div>}
        </div>
      </div>
    </header>
  );
};

export default BookingHeader;
